export enum Authority {
    ADMIN = 'ROLE_ADMIN',
    USER = 'ROLE_USER',
    MODERATOR = 'ROLE_MODERATOR',
}
